export default __webpack_public_path__ + "static/media/d.2be09573.png";